<template>
  <div class="sac-left-side-bar">
    <div class="sac-lsb-options">
      <h3 class="sac-title">Settings</h3>
      <div v-for="(op, index) in options" class="sac-lsb-section">
        <span class="sac-label">{{ op.label }}</span>
        <div
          v-for="(option, idx) in op.subOptions"
          :key="idx"
          :class="[
            'sac-lsb-option',
            activeTab === option.value ? 'active' : '',
          ]"
          @click="change(option.value)"
        >
          {{ option.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SACLeftSideBar',
  props: {
    options: Array,
    activeTab: String,
    change: Function,
  },
};
</script>

<style lang="scss" scoped>

.sac-left-side-bar {
  min-width: 240px;
  height: 100%;
  border-right: 1px $NBLUE110 solid;
  background: #F6F6F7;
  .sac-title{
    font-size: 18px;
    font-weight: 400;
    margin: 15px 0px 0px 0px;
  }
  .sac-lsb-options {
    display: grid;
    grid-auto-flow: row;
    padding-left: 20px!important;
    .sac-lsb-section{
      margin-top: 15px;
    }
    .sac-label {
      font-size: 12px;
    }
    .sac-lsb-option {
      cursor: pointer;
      padding-left: 0px!important;
      padding-top: 6px;
      padding-bottom: 6px;
      font-weight: 400;
      font-size: 13px;
      color: $N60;
      &:hover {
        color: $NBLUE100;
      }
      &.active {
        color: $NBLUE110;
        font-weight: 600;
      }
    }
  }
}
</style>
